import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { find, flatten } from 'lodash'
import React, { Component } from 'react'
import DtoSource from '../../dto/DtoSource'
import DtoUser from '../../../home/dto/DtoUser'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import { getLegendUrl } from '../../../utils/mapUtils/LegendUtils'
import { nFormatter } from '../../../utils/NumberUtils'
import Avatar from '@material-ui/core/Avatar'
import Icon from '@material-ui/core/Icon'
import Chip from '@material-ui/core/Chip'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import { connect } from 'react-redux'
import DtoDataTypeStatistics from '../../dto/DtoDataTypeStatistics'
import { getPlurialWithNumber } from '../../../utils/StringUtils'
import { Tooltip } from '@material-ui/core'

class ThemePanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			height: 0,
			layers: this.getLayers(props)
		}
		this.toggleLayer = this.toggleLayer.bind(this)
		this.openMap = this.openMap.bind(this)
	}

	openMap() {
		if (this.state.height === 0) {
			this.setState({ height: 400 })
		}
	}

	toggleLayer(layer) {
		this.setState(prevState => {
			const layers = Object.assign([], prevState.layers)
			return {
				layers: layers.map(l => {
					if (layer.id === l.id) {
						l.visibility = !l.visibility
					}
					return l
				})
			}
		})
	}

	getLayers = (props) => {
		return props.theme.layers.map(l => {
			return Object.assign({}, l, {
				visibility: true
			})
		})
	}

	getCollectionLegend = (firstColName, ratio = [6, 6]) => {
		return (
			<div className='row no-margin'>
				<div className='collection-legend valign-wrapper'>
					<div className={ `col s${ ratio[0] } center-align` }>
						{ firstColName }
					</div>
					<div className={ `col s${ ratio[0] } center-align` }>
						{ i18n.sources }
					</div>
				</div>
			</div>
		)
	}

	getPopupComponent = (picture, index, title, content) => {
		if (picture) {
			const gallery = 'gallery_' + index
			return (
				<div className='col s1 theme-icon-column valign-wrapper icon-img no-padding'>
					<a data-fancybox={ gallery } href={ picture } data-caption={ title }>
						{ content }
					</a>
				</div>
			)
		}
		return null
	}

	getDetail = (title, source = null, before = null, after = null, ratio = [6, 6]) => {
		return (
			<div className='row no-margin valign-wrapper theme-icon-column'>
				<div className={ `col s${ ratio[0] } no-padding` }>
					<div className='row no-margin valign-wrapper'>
						<div className='col s1'>
							{ before }
						</div>
						<div className='col s8 margin-left-10 no-padding'>
							<span className='title'>{ title }</span>
						</div>
						<div className='col s3 left-align no-padding'>
							{ after }
						</div>
					</div>
				</div>
				<div className={ `col s${ ratio[1] }` }>
					{ source }
				</div>
			</div>
		)
	}

	getComponent = (component) => {
		return (
			<div>
				{ component }
			</div>
		)
	}

	openUrl = (url) => {
		window.open(url, '_blank')
	}

	getSource(id) {
		const source = find(this.props.sources, s => s.id === id)
		if (source) {
			return (
				<div className='row no-margin valign-wrapper cursor-pointer' onClick={ () => this.openUrl(source.url) }>
					<div className='col s3 no-padding'>
						<Avatar src={ source.logo } className='MuiAvatar-root-source'/>
					</div>
					<div className='col s9 no-padding'>
						{ source.name }
					</div>
				</div>
			)
		}
		return null
	}

	getNbDataComponent = (siteType) => {
		const nbData = siteType.nbSites
		if (nbData) {
			return (
				<Chip
					size={ 'small' }
					label={ nFormatter(nbData) + ' ' + getPlurialWithNumber(i18n.availablePoint, i18n.availablePoints, nbData) }
				/>
			)
		}
		return (
			<Chip
				size={ 'small' }
				label={ i18n.noSites }
			/>
		)
	}

	getSiteTypeComponent(theme) {
		const siteTypes = theme.siteTypes.map(s => {
			const site = SiteTypes[s.type]
			const icon = (() => {
				if (site.icon) {
					return (
						<img src={ site.icon } className='responsive-img theme-icon center-align'/>
					)
				}
				return null
			})()
			const nbData = this.getNbDataComponent(s)
			return this.getDetail(site.title, this.getSource(s.source), icon, nbData, [10, 2])
		})
		return this.getComponent(siteTypes)
	}

	getLayerDetails(l, id, legendUrl) {
		const title = `${ l.name } - ${ l.type }`
		const url = getLegendUrl(legendUrl)
		const legend = this.getPopupComponent(url, id, title, (
			<Tooltip title={ i18n.legend } aria-label={ i18n.legend }>
				<Icon className='material-icons font-size-15' color={ '#48a1ff' }>info</Icon>
			</Tooltip>
		))
		const informations = (
			<div className='row no-margin valign-wrapper'>
				<div className='col s5 font-size-12'>
					{ l.updateDate }
				</div>
				<div className='col s5 font-size-12 '>
					<span>{ l.zoom }</span>
				</div>
				<div className='col s2 left-align'>
					{ legend }
				</div>
			</div>
		)
		return this.getDetail(title, this.getSource(l.source), null, informations, [10, 2])
	}

	getLayersComponent(theme, id) {
		const layers = flatten(theme.layers.map(l => this.getLayerDetails(l, id, l)))
		return (
			<div>
				{ this.getComponent(layers, 4.5) }
			</div>
		)
	}

	render() {
		const t = this.props.theme
		const id = this.props.id
		return (
			<div>
				<Card>
					<CardHeader
						title={ i18n.stationTypes + ' (' + t.siteTypes.length + ')' }
						className='no-padding font-size-15'
					/>
					{ this.getSiteTypeComponent(t) }
				</Card>
				<Card>
					<CardHeader
						title={ i18n.cartographicLayers + ' (' + t.layers.length + ')' }
						className='no-padding font-size-15'
					/>
					{ this.getLayersComponent(t, id) }
				</Card>
			</div>
		)
	}
}

ThemePanel.propTypes = {
	theme: PropTypes.object,
	id: PropTypes.string,
	user: PropTypes.objectOf(DtoUser),
	sources: PropTypes.arrayOf(PropTypes.objectOf(DtoSource)),
	dataTypeStatistics: PropTypes.arrayOf(PropTypes.objectOf(DtoDataTypeStatistics))
}
const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		sources: store.AdministrationReducer.sources,
		dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
	}
}

export default connect(mapStateToProps)(ThemePanel)



// WEBPACK FOOTER //
// ./src/administration/components/themeinformation/ThemePanel.js